'use strict';

export const viewport = (() => {
    let headerHeight = 0;

    const init = () => {
        uaJudge();

        watchLoad();
    };

    const watchLoad = () => {

        if ($('.view-replaced').length) {
            return resetPos();
        } else {
            setTimeout(() => {
                return watchLoad();
            }, 10);
        }
    }

    const resetPos = () => {
        if (location.hash) {
            pageAnchor();
        } else {
            $("html,body").animate({ scrollTop: 0 }, 0);
        }
    }

    const uaJudge = () => {
        var ua = window.navigator.userAgent.toLowerCase();

        if ((ua.indexOf('iphone') > 0) || ua.indexOf('ipod') > 0 || (ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0)) {
            $.when(
                $('head>meta[name="viewport"]').replaceWith('<meta name="viewport" content="width=device-width, initial-scale=1.0,maximum-scale=1.0,user-scalable=no" />')
            ).done(function () {
                $('body').addClass('view-replaced');
            });
        } else if (ua.indexOf('ipad') > 0 || ua.indexOf('macintosh') > 0 && 'ontouchend' in document || ua.indexOf('android') > 0) {
            $.when(
                $('body').addClass('tab')
            ).done(function () {
                $('body').addClass('view-replaced');
            });
        } else {
            $('body').addClass('view-replaced');
        }
    }

    const pageAnchor = () => {
        let $wWidth = $(window).outerWidth();
        let pos = $('.layout-header').height();

        setTimeout(() => {
            if ($wWidth <= 768) {
                headerHeight = $('.layout-header__inner').height();
                pos = $(location.hash).offset().top - headerHeight;
            } else {
                headerHeight = $('.layout-header').height();
                pos = $(window).scrollTop() - headerHeight;
            }

            $("html,body").animate({ scrollTop: pos }, 0);
        }, 100);
    }

    return {
        init: init
    };
})();
